define('InventoryStockLocation.View',
	[
	'SCView',
	'inventory_stock_location.tpl',	
	'Backbone',
	'jQuery',
	'underscore'
    ],
	 function InventoryStockLocationView(
	SCViewComponent,
	inventory_stock_location_tpl,
	Backbone,
	jQuery,
	_
)
{
    'use strict';

	var SCView = SCViewComponent.SCView;
	
	//Grabs the reason for non returnable from the variable name, 'No-Zip Ship' -> Zip Ship
	function splitReturnableStatus(status) {
		if (status && status != 'Yes') {
		return status.split('-')[1].trim();
		} else {
			return 'N/A'
		}
	}

	function InventoryStockLocationView(options) {
		var self = this;
		SCView.call(this);
		

		this.options = options || {};
		this.container = options.container;

		this.template = inventory_stock_location_tpl;																																																																															
		
		this.quantity;
		this.location;
		this.noItem = false
		this.wisconsinQuantity = 0;
		this.nevadaQuantity = 0;
		this.mississippiQuantity = 0;

		// this.item = this.contextData.item && this.contextData.item();

		this.pdpitem = this.options.pdp.getItemInfo();
		self.locations = this.pdpitem.item.quantityavailable_detail.locations;
		this.stockingStatus = this.pdpitem.item.custitem_stocking_status;
		this.customStockMessage = this.pdpitem.item.custitem_alt_out_of_stock_message;

		this.returnableStatus = this.pdpitem.item.custitem_returnable_status;
		this.nonReturnableItem = splitReturnableStatus(this.returnableStatus)


		for (let i = 0; i < this.pdpitem.item.quantityavailable_detail.locations.length; i ++) {
			var currentLocation = this.pdpitem.item.quantityavailable_detail.locations[i].internalid;
			var currentLocationObject = this.pdpitem.item.quantityavailable_detail.locations[i];
			if (currentLocation === 2) {
				this.wisconsinQuantity = currentLocationObject.quantityavailable;
			}
			if (currentLocation === 13) {
				this.nevadaQuantity = currentLocationObject.quantityavailable;
			}
			if (currentLocation === 1) {
				this.mississippiQuantity = currentLocationObject.quantityavailable;				
			}
		}

		if (self.locations.length == 0){
			self.noItem = true;
		}else {

			self.locArr = _.map(self.locations, function(ab,c){
				if (ab.internalid == '1') {
					ab.location = "Mississippi"
				}else if (ab.internalid =='2') {
					ab.location = "Wisconsin"
				}else {
					ab.location = "Nevada"
				}
					
				return ab 
			})
		}

		self.render();
	}

	// Inherit parent instance methods.
	InventoryStockLocationView.prototype = Object.create(SCView.prototype);

	// Restore the constuctor.
	InventoryStockLocationView.prototype.constructor = InventoryStockLocationView;

	InventoryStockLocationView.prototype.getContext = function() {


		return {
			locations: this.locArr,
			noItem: this.noItem,
			MsQuantity: this.mississippiQuantity.toLocaleString('en-US'),
			WiQuantity: this.wisconsinQuantity.toLocaleString('en-US'),
			NvQuantity: this.nevadaQuantity.toLocaleString('en-US'),
			stockingStatus: this.stockingStatus,
			customStockMessage: this.customStockMessage,
			isZipOrSpecial: (this.stockingStatus === 'Zip Ship') || (this.stockingStatus === 'Special Order'),
			hasStock: this.pdpitem.item.quantityavailable > 0,
			nonReturnable: (this.returnableStatus != 'Yes'),
			nonReturnableItemLabel: this.nonReturnableItem

		}
	}

	InventoryStockLocationView.prototype.validateContextDataRequest = function() {
		return true;
	}

	InventoryStockLocationView.prototype.contextDataRequest = ['item'];

	// Return the AMD constructor.
	return InventoryStockLocationView;

});
